import { useState } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Button, CloseButton } from '../../../../../components';
import AudioPlayer from '../../../../../components/AudioPlayer';

interface AudioPlayButtonProps {
  isCompact?: boolean;
}

export const AudioPlayButton = ({
  isCompact = false,
}: AudioPlayButtonProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <>
      {isCompact ? (
        <PlayArrowIcon
          className="text-purple-800 cursor-pointer border border-purple-800 rounded-full p-1"
          onClick={handlePlayClick}
          fontSize="large"
        />
      ) : (
        <Button
          type="contrast"
          size="small"
          className="bg-purple-200 text-purple-800"
          label="▶ Listen"
          onClick={handlePlayClick}
        />
      )}
      {isPlaying && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white pt-10 pb-4 px-10 rounded-lg relative">
            <div className="absolute top-2 right-2">
              <CloseButton onClick={() => setIsPlaying(false)} />
            </div>
            <AudioPlayer src="https://www.w3schools.com/html/mov_bbb.mp4" />
          </div>
        </div>
      )}
    </>
  );
};
